import { z } from 'zod';

const BooleanFlag = z
  .enum(['true', 'false'])
  .default('false')
  .transform((v) => v === 'true');

export const EnvSchema = z
  .object({
    APP_ENV: z.enum(['localhost', 'development', 'staging', 'preprod', 'production']),
    APP_URL: z.string(),

    BOP_API_BASE_URL: z.string(),
    BOP_WS_BASE_URL: z.string(),
    CRYPTO_INFO_BASE_URL: z.string(),
    FAST_API_BASE_URL: z.string(),
    MARKET_MAKER_BASE_URL: z.string().optional(),

    SENTRY_ENABLED: BooleanFlag,
    LOG_LEVEL: z.enum(['debug', 'info', 'warn', 'error', 'silent']).default('info'),
  })
  .transform((data) => ({
    ...data,
    IS_LOCAL: data.APP_ENV === 'localhost',
    IS_NON_PROD: data.APP_ENV !== 'production',
    MARKET_MAKER_ENABLED: data.APP_ENV !== 'production' && !!data.MARKET_MAKER_BASE_URL,
    // Off where fast-api still collects V1 institution details, as it has nothing to upgrade to there
    INSTITUTION_DETAILS_UPGRADE_ENABLED: data.APP_ENV !== 'preprod' && data.APP_ENV !== 'production',
  }));

export type Env = z.infer<typeof EnvSchema>;

const stripVitePrefix = (env: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(env)
      .filter(([key]) => key.startsWith('VITE_'))
      .map(([key, value]) => [key.replace(/^VITE_/, ''), value]),
  );

// Parsed once at module load — the app fails fast on a bad build configuration.
export const config: Env = EnvSchema.parse(stripVitePrefix(import.meta.env));
